import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGutterVertical16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconGutterVertical16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 2.5a.5.5 0 0 0-1 0V3a2 2 0 0 0 2 2h7.998a2 2 0 0 0 2-2v-.5a.5.5 0 1 0-1 0V3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8m9.498 5.998a.5.5 0 0 1-.5-.5V13a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v.498a.5.5 0 1 1-1 0V13a2 2 0 0 1 2-2h7.998a2 2 0 0 1 2 2v.498a.5.5 0 0 1-.5.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGutterVertical16);
